export const rootPaths = {
  root: '/', 
  // appsRoot: 'app',
  errorsRoot: 'errors',
  userRoot: 'user',
  authRoot: 'authentication',
  adminRoot: 'admin',
  homeRoot: 'home',
  checkout: 'checkout'

};

 const Paths = { 
  landing: '/',
  home: '/',
  root:  `/${rootPaths.root}`,
  Login: `/${rootPaths.authRoot}/login`,
  checkout: '/checkout',
  payment_success: `/${rootPaths.checkout}/success`,
  store: '/sarees',
  womenKurtasKurtis: '/women-kurtas-kurtis-suits',
  tracking: '/tracking',
  privacyPolicy: '/privacy-policy',
  termsConditions: '/terms-conditions',
  shippingPolicy: '/shipping-policy',
  contactUs: '/contact-us',
  returnExchangePolicy: '/return-exchange-policy',
  offers: '/limited-time-offers',
  error404: `/${rootPaths.errorsRoot}/404`,
  error500: `/${rootPaths.errorsRoot}/500`,
  userProfile: `/${rootPaths.userRoot}/profile`,
  //userSettings: `/${rootPaths.userRoot}/settings`,
  userDashboard: `/${rootPaths.userRoot}/dashboard`,
  userWishlist: `/${rootPaths.userRoot}/wishlist`,
  userProfiles: `/${rootPaths.userRoot}/profiles`,
  userOrders: `/${rootPaths.userRoot}/orders`,
  userAddresses: `/${rootPaths.userRoot}/addresses`,
  adminDashboard: `/${rootPaths.adminRoot}/dashboard`,
  adminUsers: `/${rootPaths.adminRoot}/users`,
  subCategories: categoryId =>
    `/subcategories${
      categoryId ? `/${categoryId}` : ''
  }`,
  productDetails: productId =>
    `/shop${
      productId ? `/${productId}` : ''
    }`,

  sellerSarees:  `/${rootPaths.adminRoot}/seller/Sarees`,
  sellerKurtis:  `/${rootPaths.adminRoot}/seller/Kurtis`,

  
};

export default Paths;